import * as React from 'react';
export const GWSvg = React.forwardRef(function GWSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M1.998 2A2.005 2.005 0 0 0 0 4.009v7.982C0 13.101.898 14 1.998 14H6V2H1.998Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        fillRule: 'nonzero',
        d: 'm5.296 7.167-1.458.003a.202.202 0 0 1-.193-.14l-.452-1.388a.202.202 0 0 0-.386 0l-.45 1.387a.202.202 0 0 1-.193.14H.704a.202.202 0 0 0-.118.368l1.18.857a.202.202 0 0 1 .073.227l-.45 1.388a.202.202 0 0 0 .312.227l1.18-.792a.202.202 0 0 1 .239 0l1.18.792a.202.202 0 0 0 .313-.227L4.161 8.62a.202.202 0 0 1 .074-.227l1.18-.857a.205.205 0 0 0-.12-.37Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M14.14 2C15.167 2 16 3.02 16 4.276V8H6V2h8.14Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 8V4a1 1 0 0 0-1-1H6V2h8a2 2 0 0 1 2 2v4h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M16 12.257c0 .961-.832 1.743-1.86 1.743H6V8h10v4.257Z',
      }),
    ),
  );
});
GWSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var GW = {
  category: 'flag',
  colorable: false,
  name: 'GW',
  svg: GWSvg,
};
